import { useCustomClient } from '@uag/react-core';
import { create, type AxiosRequestConfig } from 'axios';

import { installAxiosLog } from 'app/apiLog';

export const apiClient = create({
    baseURL: import.meta.env.VITE_APP_API_URL
});

// Times every call for the console API log (pih.api(true), see app/apiLog.ts) - silent while off.
installAxiosLog(apiClient);

export const useCustomAppClient = <T,>(): ((config: AxiosRequestConfig) => Promise<T>) => useCustomClient<T>(true);
